import React from 'react';
import { useToast } from '../hooks/useToast';
import './ToastContainer.css';

const ICONS: Record<string, string> = {
  success: '✅',
  error: '❌',
  warning: '⚠️',
  info: 'ℹ️',
};

const ToastContainer: React.FC = () => {
  const { toasts, dismiss } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" role="region" aria-label="Notifications">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.type}`} onClick={() => dismiss(t.id)}>
          <span className="toast-icon">{ICONS[t.type]}</span>
          <div className="toast-body">
            <span className="toast-message">{t.message}</span>
            {t.detail && <span className="toast-detail">{t.detail}</span>}
            {t.link && (
              <a
                className="toast-link"
                href={t.link.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                {t.link.label} ↗
              </a>
            )}
          </div>
          <button className="toast-close" aria-label="Dismiss">×</button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
